  import './RocketSection.css';
import { useState  } from 'react';

function RocketSection({  }) {


const [gifLoaded, setGifLoaded] = useState(false);

const Line = ({text}) =>
<div className='rocket-line color-blue-dark' style={{display:"flex" ,  alignItems:"center" , justifyContent:"flex-end"  }}>
 <h5  className='rocket-line-mobile'>{text}</h5>
 <img className='rocket-bulit' src="icons/icon-plus.svg"alt="rocket" style={{   }}  />
</div>

return (


//////////////////////////////להחלחיףב PICTURE....???????????

<section  className="rocketSection">
 
<div  className="rocketSectionFlex" >

  {/* <div className="theRocket"  style={{ }}> */}
 {/* <img src="rocket/rocket_movie_610w.gif"alt="rocket" className="theRocket-main-pic "  /> */}

 <div className="theRocket-placeholder">
      {!gifLoaded && (
        <img
          src="rocket/rocket_movie_610w_preview.png"
          alt="rocket placeholder"
          className="theRocket-main-pic"
        />
      )}
      <img
        src="rocket/rocket_movie_610w.gif"
        alt="rocket"
        style={{ display: gifLoaded ? "block" : "none" }}
        onLoad={() => setGifLoaded(true)}
        className="theRocket-main-pic"
      />
    </div>


{/* </div> */}

 <div  className='theText'>
 <h2 className='  color-blue-dark  '>ממריאים נכון</h2>
<Line text="עיצוב עם חשיבה עסקית"/>
<Line text="שיווק שמכוון תוצאות"/>
<Line text="ניסיון של 15 שנה עם מותגים מובילים"/>
 </div>
 
</div>
 
</section >
);
}

export default RocketSection;